import IconButton from "components/Common/IconButton/IconButton"
import SnackbarComponent from "components/SnackBar"
import React from "react"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, CardTitle, Col, Input, Label, Row } from "reactstrap"

const CampaignForm = ({ formData, setFormData, colors, mode }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState("")
  const [success, setSuccess] = useState("")
  const today = new Date().toISOString().split("T")[0]

  const handleInputChange = e => {
    const { name, value } = e.target
    const today = new Date().toISOString().split("T")[0]

    setFormData(prevState => {
      const updatedCampaign = { ...prevState.campaign, [name]: value }
      let errorMessage = ""
      if (name === "startDate") {
        if (value < today) {
          errorMessage = "Start date cannot be in the past."
        } else if (updatedCampaign.endDate && updatedCampaign.endDate < value) {
          errorMessage = "End date cannot be before the start date."
          updatedCampaign.endDate = ""
        }
      }
      if (name === "endDate") {
        if (updatedCampaign.startDate && value < updatedCampaign.startDate) {
          errorMessage = "End date cannot be before the start date."
        }
      }
      setErr(errorMessage)
      if (errorMessage) setLoading(false)

      return {
        ...prevState,
        campaign: updatedCampaign,
      }
    })
  }

  return (
    <div>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <Row className="justify-content-center">
        <Col xl={12}>
          <Card className="shadow-sm br">
            <CardBody>
              <Row className="align-items-center mb-3">
                <Col xl={6} lg={6} md={6} className="d-flex align-items-center">
                  <CardTitle
                    className="h2mb-0 text-uppercase"
                    style={{
                      margin: 0,
                      fontSize: 16,
                      color: colors.text,
                      fontWeight: 700,
                    }}
                  >
                    Create New Campaign
                  </CardTitle>
                </Col>
              </Row>

              <Row className="mt-3">
                {/* Campaign Title */}
                <Col md={6}>
                  <div className="mb-3">
                    <Label
                      className="form-label"
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        color: mode === "dark" ? "#fff" : "#666",
                      }}
                    >
                      Campaign Title{" "}
                      <i
                        className="mdi mdi-information-outline"
                        title="Give your campaign a title."
                        style={{ color: mode === "dark" ? "#fff" : "#2990DF" }}
                      ></i>
                    </Label>
                    <Input
                      minLength={5}
                      name="campaignTitle"
                      placeholder="eg.. June 2023 Campaign"
                      type="text"
                      onChange={handleInputChange}
                      value={formData.campaign.campaignTitle}
                      style={{
                        height: "45px",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        color: mode === "dark" ? "#fff" : "#000",
                      }}
                    />
                  </div>
                </Col>

                {/* Campaign Description */}
                <Col md={6}>
                  <div className="mb-3">
                    <Label
                      className="form-label"
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        color: mode === "dark" ? "#fff" : "#666",
                      }}
                    >
                      Campaign Description{" "}
                      <i
                        className="mdi mdi-information-outline"
                        title="Write a description for your campaign."
                        style={{ color: mode === "dark" ? "#fff" : "#2990DF" }}
                      ></i>
                    </Label>
                    <Input
                      minLength={10}
                      name="campaignDescription"
                      placeholder="eg.. This campaign covers patients feedback for June"
                      type="text"
                      value={formData.campaign.campaignDescription}
                      onChange={handleInputChange}
                      style={{
                        height: "45px",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        color: mode === "dark" ? "#fff" : "#000",
                      }}
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                {/* Start Date */}
                <Col md={3}>
                  <div className="form-group">
                    <Label
                      className="form-label"
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        color: mode === "dark" ? "#fff" : "#666",
                      }}
                    >
                      Start Date{" "}
                      <i
                        className="mdi mdi-information-outline"
                        title="When do you want your campaign to start."
                        style={{
                          color: mode === "dark" ? "#fff" : "#2990DF",
                        }}
                      ></i>
                    </Label>
                    <Input
                      type="date"
                      name="startDate"
                      min={today}
                      value={formData.campaign.startDate}
                      onChange={handleInputChange}
                      style={{
                        height: "45px",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        color: mode === "dark" ? "#fff" : "#000",
                      }}
                    />
                  </div>
                </Col>

                {/* End Date */}
                <Col md={3}>
                  <div className="form-group">
                    <Label
                      className="form-label"
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        color: mode === "dark" ? "#fff" : "#666",
                      }}
                    >
                      End Date{" "}
                      <i
                        className="mdi mdi-information-outline"
                        title="When do you want to end your campaign."
                        style={{
                          color: mode === "dark" ? "#fff" : "#2990DF",
                        }}
                      ></i>
                    </Label>
                    <Input
                      type="date"
                      name="endDate"
                      min={formData.campaign.startDate || today}
                      value={formData.campaign.endDate}
                      onChange={handleInputChange}
                      style={{
                        height: "45px",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        color: mode === "dark" ? "#fff" : "#000",
                      }}
                    />
                  </div>
                </Col>

                {/* Cycle */}
                <Col md={3}>
                  <div className="form-group">
                    <Label
                      className="form-label"
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        color: mode === "dark" ? "#fff" : "#666",
                      }}
                    >
                      Cycle{" "}
                      <i
                        className="mdi mdi-information-outline"
                        title="The reminder repetition cycle for the campaign."
                        style={{
                          color: mode === "dark" ? "#fff" : "#2990DF",
                        }}
                      ></i>
                    </Label>
                    <Input
                      type="select"
                      name="cycle"
                      value={formData.campaign.cycle}
                      onChange={handleInputChange}
                      style={{
                        height: "45px",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        color: mode === "dark" ? "#fff" : "#000",
                      }}
                    >
                      <option value="">Select Cycle for reminders</option>
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                    </Input>
                  </div>
                </Col>

                {/* Frequency */}
                <Col md={3}>
                  <div className="form-group">
                    <Label
                      className="form-label"
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        color: mode === "dark" ? "#fff" : "#666",
                      }}
                    >
                      Frequency{" "}
                      <i
                        className="mdi mdi-information-outline"
                        title="How many selected cycles to send the reminder of survey to customers. eg(3 times a week)"
                        style={{
                          color: mode === "dark" ? "#fff" : "#2990DF",
                        }}
                      ></i>
                    </Label>
                    <Input
                      name="frequency"
                      className="form-control"
                      max={2}
                      min={0}
                      placeholder="Enter repetition frequency"
                      type="number"
                      value={formData.campaign.frequency}
                      onChange={handleInputChange}
                      style={{
                        height: "45px",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        color: mode === "dark" ? "#fff" : "#000",
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default CampaignForm
